import { Layout, Typography } from 'antd';

const { Footer } = Layout;

const TeamAdminFooter = () => {
  return (
    <Footer style={{ textAlign: 'center' }}>
      <Typography.Title level={5}>40K Team Admin ©2025</Typography.Title>
    </Footer>
  );
};

export default TeamAdminFooter;
